import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingShimmerModule } from 'loading-shimmer';
import { Breadcrumb } from '../../../models/shared/stylesheet/breadcrumb';
import { HeaderContainerComponent } from '../../../views/shared/components/header-container/header-container.component';
import { BreadcrumbsComponent } from '../../breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'app-breadcrumb-content-header',
  standalone: true,
  imports: [CommonModule, HeaderContainerComponent, BreadcrumbsComponent, LoadingShimmerModule],
  templateUrl: './breadcrumb-content-header.component.html',
  styleUrls: ['../../../views/shared/components/breadcrumb-header/breadcrumb-header.component.scss']
})
export class BreadcrumbContentHeaderComponent {
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() isMobile: boolean = false;
  @Input() isLoading: boolean = false;
}
